import * as React from 'react'
import styled from 'styled-components/macro'
import HomeTopBannner from 'assets/images/HomeImages/HomeTopBanner.jpg'
import HomePageMenu from './HomePageMenu'
// import ShopServicesBanner from './ShopServicesBanner'
import {Link} from 'react-router-dom'
import HomeServices from './HomeServices'
import UnforgettableSection from './UnforgettableSection'
import FeaturedServices from './FeaturedServices'
import {QUERIES} from 'common/constants'
import RequestQuotePopup from 'common/RequestQuotePopup'
import InstagramRow from 'common/InstagramRow'

const TopImageSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media ${QUERIES.tabletAndUp} {
    justify-content: center;
    height: 800px;
  }
  position: relative;
  img {
    object-fit: cover;
  }
`

const TopBannerImage = styled.img`
  height: 516px;
  @media ${QUERIES.tabletAndUp} {
    height: 800px;
  }
  width: 100vw;
  filter: brightness(55%);
`

const Banner = styled.div`
  color: var(--white);
  display: block;
  position: absolute;
  top: 180px;
  gap: 16px;
  @media ${QUERIES.tabletAndUp} {
    top: 283px;
  }
  width: clamp(200px, 85%, 1200px);
  justify-content: center;
`

const BannerTitle = styled.h2`
  text-transform: uppercase;
  font-size: calc(32 / 16 * 1rem);
  line-height: 32px;
  margin-bottom: 16px;
  @media ${QUERIES.tabletAndUp} {
    font-size: calc(50 / 16 * 1rem);
    line-height: 50px;
  }
  font-weight: 700;
`

const BannerMesssage = styled.div`
  color: var(--white);
  font-size: calc(16 / 16 * 1rem);
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  @media ${QUERIES.tabletAndUp} {
    line-height: 28px;
    font-size: calc(24 / 16 * 1rem);
  }
  font-weight: 300;
  font-family: 'Mulish';
  margin-bottom: 16px;
`

const StyledLink = styled(Link)`
  color: var(--white);
  font-size: calc(16 / 16 * 1rem);
  font-weight: 300;
  font-family: 'Mulish';
  @media ${QUERIES.tabletAndUp} {
    font-size: calc(24 / 16 * 1rem);
  }
`

const Home = () => {
  return (
    <>
      {/* <ShopServicesBanner /> */}
      <TopImageSection>
        <TopBannerImage src={HomeTopBannner} />
        <Banner>
          <BannerTitle>a trusted leader in golf event services</BannerTitle>
          <BannerMesssage>
            Golf Invite is an experienced golf event specialist group dedicated
            to alleviating the pressures of planning a golf event & strives to
            create a memorable experience for sponsors, attendees & you.
          </BannerMesssage>
          <StyledLink to="/about">Learn More</StyledLink>
        </Banner>
        <HomePageMenu />
        <HomeServices />
      </TopImageSection>
      <UnforgettableSection />
      <FeaturedServices />
      <InstagramRow />
      <RequestQuotePopup type="Home Page" />
    </>
  )
}
export default Home
